import styled from "@emotion/styled";
import { Colors } from '../../../../../colors';
import { Grid } from '@mui/material';

export const headerHeight = '60px'

export const HeaderStyled = {
  Container: styled(Grid) <any>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: ${headerHeight};
    background: ${Colors.White};
    padding-left: 20px;
    padding-right: 20px;
    box-shadow: 0 2px 30px -2px rgba(0, 0, 0, 0.16);
    z-index: 101;
    position: fixed;
  `,
  ContainerMenuUser: styled(Grid) <any>`
    display: flex; 
    justify-content: end;
    align-items: center;
  `,
  MenuTitle: styled.p<any>`
    font-family: EncodeSans-Medium;
    font-size: 17px;
    color: ${Colors.Black};
  `,
  ContainerIconMenu: styled.div<any>`
    margin-left: 10px;
  `,
  ContainerLogo: styled(Grid) <any>`
    
  `,
};


export const sxHeader = {
  menuItem: {
    fontFamily: 'EncodeSans-Regular',
    fontSize: 15
  },
  accountIcon: {
    color: Colors.Primary
  }
}
